export default "__VITE_ASSET__BpAHE3Kz__"